// extracted by mini-css-extract-plugin
export var contrastLow = "_2t-1";
export var externalLink = "_2t-2";
export var externalLinkIcon = "_2t-3";
export var link = "_2t-0";
export var linkLabel = "_2t-4";